import { z } from 'zod';
import * as employment from '../../primitives/employment';
import * as temporal from '../../primitives/temporal';
import { RequiredMessage } from '../../validation/messages';
import { addressBlock } from './address';

export const employmentBlock = z.object({
  employeeId: employment.employeeId.schema.min(1, RequiredMessage),
  jobTitle: employment.jobTitle.schema.optional(),
  departmentId: z.string().optional(),
  divisionId: z.string().optional(),
  hireDate: temporal.hireDate.schema,
  employmentAddress: addressBlock.partial(),
});

export type EmploymentBlock = z.infer<typeof employmentBlock>;
